module.exports = __webpack_public_path__ + "static/media/ios.55a90756.png";